// global document
// global window
import React from 'react';
import { Flex, Box } from 'rebass';


import styled from 'styled-components';
import { Controller, Scene } from 'react-scrollmagic';
import NavCell from '../components/navcell';
import Obj0 from '../components/obj/obj0';
import Obj1 from '../components/obj/obj1';
import Obj2 from '../components/obj/obj2';
import Obj3 from '../components/obj/obj3';
import Obj4 from '../components/obj/obj4';
import Obj5 from '../components/obj/obj5';
import Obj6 from '../components/obj/obj6';
import Obj7 from '../components/obj/obj7';
import Obj8 from '../components/obj/obj8';
import Obj9 from '../components/obj/obj9';
import Obj10 from '../components/obj/obj10';
import Obj11 from '../components/obj/obj11';
import Obj12 from '../components/obj/obj12';


const ClassToggleStyled = styled.div`
  .active {
    background-color: #2e3440;
    color: white;
  }

  .section {
    height: 100vh;
  }

  .test {
	  transition: width 0.3s ease-out;
	  width: 100px;
    height: 100px;
    background-color: red;
    margin: 0 !important;

    &.yellow {
      background-color: yellow;
    }
  }
  .sticky {
    background-color: red;
    width: 100%;
  }
`;

const Nav = () => {
  return (
    <Flex
      id='objectives'
      fontSize={[ 1, 2 ]}
      fontWeight='700'
      flexDirection='column'
      height='70vh'
      alignItems='center'
      justifyContent='space-evenly'
    >
      <NavCell text='0' nav='0' />
      <NavCell text='1' nav='1' />
      <NavCell text='2' nav='2' />
      <NavCell text='3' nav='3' />
      <NavCell text='4' nav='4' />
      <NavCell text='5' nav='5' />
      <NavCell text='6' nav='6' />
      <NavCell text='7' nav='7' />
      <NavCell text='8' nav='8' />
      <NavCell text='9' nav='9' />
      <NavCell text='10' nav='10' />
      <NavCell text='11' nav='11' />
      <NavCell text='12' nav='12' />
    </Flex>
  )
}

const Objectives = () => {
  const getHeight = (id) => {
    return window.getComputedStyle(document.getElementById(id)).height.slice(0,-2) - 3
  }
  return (
    <Flex fontFamily='Roboto' fontWeight='400' width='100%' id='objectivess'>

      <Box width={['20vw', '10vw']}>
      <ClassToggleStyled>
        <div id="trigger" />
        <Controller >
          <Scene duration={33200} pin={true} triggerElement="#trigger" triggerHook="0.3" indicators={false}>
           <div>
            <Nav />
           </div>
          </Scene>
        </Controller>
      </ClassToggleStyled>
      </Box>

      <Flex
        flexDirection="column"
        color='gray'
        fontSize={[ '16px', '18px' ]}
        width={['80vw', '85vw']}
        mx={['3vw', '6vw']}>
      <Controller >
        <div style={{height: '10vh'}}/>
        <Scene duration={() => getHeight('0')} triggerHook="onLeave" classToggle={['#nav_0', 'active']} indicators={false}>
          <Box id='0'>
           <Obj0 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('1')} triggerHook="onLeave" classToggle={['#nav_1', 'active']} indicators={false}>
        <Box id='1'>
         <Obj1 />
        </Box>
        </Scene>

        <Scene duration={() => getHeight('2')} triggerHook="onLeave" classToggle={['#nav_2', 'active']} indicators={false}>
          <Box id='2'>
            <Obj2 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('3')} triggerHook="onLeave" classToggle={['#nav_3', 'active']} indicators={false}>
          <Box id='3'>
            <Obj3 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('4')} triggerHook="onLeave" classToggle={['#nav_4', 'active']} indicators={false}>
          <Box id='4'>
            <Obj4 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('5')} triggerHook="onLeave" classToggle={['#nav_5', 'active']} indicators={false}>
          <Box id='5'>
            <Obj5 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('6')} triggerHook="onLeave" classToggle={['#nav_6', 'active']} indicators={false}>
          <Box id='6'>
            <Obj6 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('7')} triggerHook="onLeave" classToggle={['#nav_7', 'active']} indicators={false}>
          <Box id='7'>
            <Obj7 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('8')} triggerHook="onLeave" classToggle={['#nav_8', 'active']} indicators={false}>
          <Box id='8'>
            <Obj8 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('9')} triggerHook="onLeave" classToggle={['#nav_9', 'active']} indicators={false}>
          <Box id='9'>
            <Obj9 />
          </Box>
      </Scene>

        <Scene duration={() => getHeight('10')} triggerHook="onLeave" classToggle={['#nav_10', 'active']} indicators={false}>
          <Box id='10'>
            <Obj10 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('11')} triggerHook="onLeave" classToggle={['#nav_11', 'active']} indicators={false}>
          <Box id='11'>
            <Obj11 />
          </Box>
        </Scene>

        <Scene duration={() => getHeight('12')} triggerHook="onLeave" classToggle={['#nav_12', 'active']} indicators={false}>
          <Box id='12'>
            <Obj12 />
          </Box>
        </Scene>
        <div height="12vh" />
      </Controller>
      </Flex>

    </Flex>
  );
}

export default Objectives;
